import { Partner } from '../types/partner';
import CONFIG from '../config/config';
import { instanceWithV2 } from './SimpleAPIClient';

const BASE_URL = '/v1/discovery';

export type PaginatedPartners = {
  content: Partner[];
  totalPages: number;
  totalElements: number;
  size: number;
  number: number;
};

export type TopUpCreditsResponse = {
  checkoutUrl: string;
};

export const DiscoveryAPI = {
  getPartners: (filters: {
    query?: string;
    country?: string;
    type?: string;
    minRetailers?: number;
    maxRetailers?: number;
    minInstagramFollowers?: number;
    maxInstagramFollowers?: number;
    minTiktokFollowers?: number;
    maxTiktokFollowers?: number;
    minSocialFollowers?: number;
    maxSocialFollowers?: number;
    partnersWith?: string[];
    page?: number;
    size?: number;
  }) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        if (Array.isArray(value)) {
          value.forEach(v => params.append(key, v));
        } else {
          params.append(key, value.toString());
        }
      }
    });
    return instanceWithV2(CONFIG.API_ENDPOINT)
      .get<PaginatedPartners>(`${BASE_URL}/partners?${params.toString()}`)
      .then(res => res.data);
  },

  getPartner: (id: number) =>
    instanceWithV2(CONFIG.API_ENDPOINT).get<Partner>(`${BASE_URL}/partners/${id}`).then(res => res.data),

  revealPartner: (id: number) =>
    instanceWithV2(CONFIG.API_ENDPOINT).post<Partner>(`${BASE_URL}/partners/${id}/reveal`, null).then(res => res.data),

  getCredits: () =>
    instanceWithV2(CONFIG.API_ENDPOINT)
      .get<number>(`${BASE_URL}/credits`)
      .then(res => res.data),

  topUpCredits: (amount: number) =>
    instanceWithV2(CONFIG.API_ENDPOINT).post<TopUpCreditsResponse>(`${BASE_URL}/credits/topup`, null, { 
      params: { 
        amount
      } 
    }).then(res => res.data),
}; 